var moment = require('moment-timezone');

export default class TimezoneSelector {
    constructor() {
        const timezoneSelector = this.timezoneSelector = document.querySelector(".timezone-list");

        if (timezoneSelector) {
            timezoneSelector.addEventListener('change', () => {
                const selectedTimezone = timezoneSelector.options[timezoneSelector.selectedIndex].value;

                if (selectedTimezone) {
                    const dates = document.querySelectorAll(".logged-date");

                    dates.forEach((date) => {
                        const m = moment.tz(date.dataset.utcDate, "UTC");
                        date.innerHTML = m.tz(selectedTimezone).format('MMMM DD, YYYY HH:mm');
                    });
                }
            });
        }
    }
}
